import { useMemo } from 'react';

import {
  UseRebalanceWorkloadsQuery,
  useRebalanceWorkloadsQuery,
  UseRebalanceWorkloadsQueryArgs,
  useKentRebalanceWorkloadsQuery,
} from 'hooks/queries/rebalancer';

import { useIsKentRebalancingMode } from './useIsKentRebalancingMode';
import { convertKentWorkloadToRegularWorkload } from '../_utils/kentUtils';

export const useCorrectRebalanceWorkloadsQuery = ({
  clusterId,
  enabled = true,
  refetchInterval,
}: UseRebalanceWorkloadsQueryArgs): UseRebalanceWorkloadsQuery => {
  const shouldUseKentApi = useIsKentRebalancingMode();

  const regularResponse = useRebalanceWorkloadsQuery({
    clusterId,
    enabled: enabled && !shouldUseKentApi,
    refetchInterval,
  });

  const kentResponse = useKentRebalanceWorkloadsQuery({
    clusterId,
    enabled: enabled && shouldUseKentApi,
    refetchInterval,
  });

  const convertedWorkloads = useMemo(
    () => kentResponse.workloads?.map(convertKentWorkloadToRegularWorkload),
    [kentResponse.workloads]
  );

  return shouldUseKentApi
    ? { ...kentResponse, workloads: convertedWorkloads }
    : regularResponse;
};
